import { Context, CustomQuery } from '@vue-storefront/core';
import { payMethods, payMethod, ApiResult } from '../../types';

export default async function customPayMethods(context: Context, params: CustomQuery): Promise<ApiResult> {
  const url = new URL('/mall/pmethod/get', context.config.api.url);

  const result = await context.client.post(url.href, params);
  const res = result.data;
  if (res.code === 0) {
    const data = res.data;
    const allPayMethods: payMethods = {
      list: [],
      hasIdentity: data.has_identity,
      idName: data.id_name,
      idNumber: data.id_number
    };

    if (data && data.list) {
      // 循环list
      data.list?.forEach((x) => {
        const method: payMethod = {
          id: x.id,
          enName: x.description,
          cnName: x.description,
          logoUrl: x.logo,
          payWayId: x.pay_way_id,
          createtime: x.create_time,
          currencies: x.currencies,
          customsCountries: x.customs_countries
        };
        allPayMethods.list.push(method);
      });
    }
    res.data = allPayMethods;
  }

  return res;
}
